import { combineReducers } from 'redux'

import resultados from './detalhesRemuneracao'
import remuneracao from './remuneracao'
import deducoes from './deducoes'
import totais from './totais'

export default combineReducers({ resultados, remuneracao, deducoes, totais })
